<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import './config/reset.css'
import '../static/css/style.css'

import api from './api/api'
import Vue from 'vue'

let vue = new Vue()


export default {
  beforeCreate() {
    api._setApp(this)
  },
  // computed: {
  //   footOperationDivWidth: function () {
  //     return window.innerWidth - (260 + 10) + "px";
  //   },
  // },
  methods: {},
  created() {
    //监听刷新页面事件方法
    window.onbeforeunload = function (event) {}
    // console.log('------------------------------------ ' + window.innerWidth)
  },
  mounted() {
    document.addEventListener(
      '135_change_url_success',
      function (event) {
       vue.$message({
            message: '抓取图片成功',
            type: 'success'
          })
      },
      false
    )
  }
}
</script>

<style>
#app {
  font-family: Helvetica, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue